import Vue from 'vue'
// 过滤器
// 时间格式转换
Vue.filter('formatDate', function (times) {
  if (!times) return '--'
  // 返回处理后的值
  const time = new Date(Number(times))
  const years = time.getFullYear()
  let months = time.getMonth()
  let dates = time.getDate()
  let hours = time.getHours()
  let mins = time.getMinutes()
  let seconds = time.getSeconds()

  if (hours < 10) {
    hours = '0' + hours
  }
  if (mins < 10) {
    mins = '0' + mins
  }
  if (seconds < 10) {
    seconds = '0' + seconds
  }
  if (dates < 10) {
    dates = '0' + dates
  }
  if ((months + 1) < 10) {
    months = '0' + (months + 1)
  } else {
    months = months + 1
  }
  return years + '-' + months + '-' + dates + ' ' + hours + ':' + mins 
})
// 时间格式转换
Vue.filter('cutString', function (str, len) {
  // length属性读出来的汉字长度为1

  if (str.length * 2 <= len) {
    return str
  }

  var strlen = 0

  var s = ''

  for (var i = 0; i < str.length; i++) {
    s = s + str.charAt(i)

    if (str.charCodeAt(i) > 128) {
      strlen = strlen + 2

      if (strlen >= len) {
        return s.substring(0, s.length - 1) + '...'
      }
    } else {
      strlen = strlen + 1

      if (strlen >= len) {
        return s.substring(0, s.length - 2) + '...'
      }
    }
  }

  return s
})
// 时间格式转换
Vue.filter('formatDate2', function (time) {
  if (!time) return '--'
  if (time == null) return
  time = Number(time) === 0 ? new Date() : new Date(Number(time))
  const years = time.getFullYear()
  const months = time.getMonth()
  const dates = time.getDate()
  let hours = time.getHours()
  let mins = time.getMinutes()
  if (hours < 10) {
    hours = '0' + hours
  }
  if (mins < 10) {
    mins = '0' + mins
  }
  // if ((months + 1) < 10) {
  //   var month = '0' + (months + 1)
  // }
  return years + '-' + (months + 1) + '-' + dates
})

// 时长转换
Vue.filter('duration', function (val) {
  if (val <= 0) return '--'
  if (!val) return
  val = Number(val)
  let hour = Math.floor(val / (60 * 60))
  let min = Math.floor(val / 60) % 60
  let sec = Math.floor(val) % 60
  hour = hour === 0 ? '' : hour + '小时'
  min = min === 0 ? '' : min + '分钟'
  sec = sec === 0 ? '' : sec + '秒'
  return hour + min + sec
})
Vue.filter('duration2', function (val) {
  if (val <= 0) return '--'
  if (!val) return
  val = Number(val)
  let hour = Math.floor(val / 60) % 60
  let min = Math.floor(val) % 60
  hour = hour === 0 ? '' : hour + '小时'
  min = min === 0 ? '' : min + '分钟'
  return hour + min
})
Vue.filter('formatTimeHour', function (times) {
  if (!times) return '--'
  // 返回处理后的值
  const time = new Date(Number(times))
  const years = time.getFullYear()
  let months = time.getMonth()
  let dates = time.getDate()
  let hours = time.getHours()
  let mins = time.getMinutes()
  let seconds = time.getSeconds()

  if (hours < 10) {
    hours = '0' + hours
  }
  if (mins < 10) {
    mins = '0' + mins
  }
  if (seconds < 10) {
    seconds = '0' + seconds
  }
  if (dates < 10) {
    dates = '0' + dates
  }
  if ((months + 1) < 10) {
    months = '0' + (months + 1)
  } else {
    months = months + 1
  }
  return hours + ':' + mins
})
Vue.filter('nullStr', function (val, isNumber = false) {
  if (!val) {
    if (!isNumber) {
      if (typeof val === 'number' && val === 0) {
        return 0
      } else {
        return '--'
      }
    } else {
      return 0
    }
  } else {
    return val
  }
})

Vue.filter('monetization', function(s) {
  if (![ 'string', 'number' ].includes(typeof s)) {
      return s || '---'
  }

  /* eslint-disable-next-line */
  const [ w, x, y ] = s.toString().match(/([A-Z]*)(.+)/) || []

  if (isNaN(y)) {
      return s
  }

  const ny = parseFloat(y).toFixed(2)
  const [ a, b ] = ny.toString().split('.')
  return `${ x ? `${ x } ` : '￥' }${ a.replace(/\B(?=(\d{3})+(?!\d))/g, ',') }${ b ? `.${ b }` : '.00' }`
})

Vue.filter('monetization2', function(s) {
  if (![ 'string', 'number' ].includes(typeof s)) {
      return s || '---'
  }

  /* eslint-disable-next-line */
  const [ w, x, y ] = s.toString().match(/([A-Z]*)(.+)/) || []

  if (isNaN(y)) {
      return s
  }

  const ny = parseFloat(y).toFixed(2)
  const [ a, b ] = ny.toString().split('.')
  return `${ x ? `${ x } ` : '' }${ a.replace(/\B(?=(\d{3})+(?!\d))/g, ',') }${ b ? `.${ b }` : '.00' }`
})
